export const costs = [
  'Sleepless nights searching for ways to translate complex mining concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how mining connects to their futures, careers, or global resource challenges.",
  "Awkward silences when a student asks about mine safety or environmental management and you don't have a clear answer.",
  'Weekends lost building lesson plans, mining projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach mining geology, processing, safety, environmental responsibility, or critical thinking about mining without adequate resources.',
];
